module.exports = __webpack_public_path__ + "static/img/dian_yangan.95deee8e.png";